module.exports = __webpack_public_path__ + "img/bankid.c357e5d9.png";